<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Edit Step</span>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field label="Title">
                                    <b-input v-model="data.name"></b-input>
                                </b-field>
                                <b-field label="Data">
                                    <b-input v-model="data.data" type="textarea" disabled rows="20"></b-input>
                                </b-field>
                                <b-field label="Topic" v-if="data.test_result_id===null">
                                    <b-select placeholder="Select a name" v-model="data.topic_id">
                                        <option
                                            v-for="option in topics"
                                            :value="option.id"
                                            :key="option.id">
                                            {{ option.attributes.title }}
                                        </option>
                                    </b-select>
                                </b-field>
                                <section class="m-t-md">
                                    <router-link :to="{ name: 'guide', query: { tabSelected: 'steps' } }" class="button is-default m-r-sm">Cancel</router-link>
                                    <b-button type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                                </section>
                            </div>
                            <div class="column is-half">
                                    <img :src="image" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';

export default {
    name:"StepEdit",
    data() {
        return {
            data:{
                name:null,
                topic_id:null,
                status:null,
                data:null
            },
            topics:[],
            page:1,
            image:null,
            steps:[]
        }
    },
    computed:{
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
    },
    mounted() {
        Vue.$stepService.show(this.$router.currentRoute.params.id).then((response)=>{
            this.data.name = response.data.attributes.name
            this.data.topic_id = response.data.attributes.topic_id
            this.data.data = JSON.stringify(response.data.attributes.data)
            this.data.status = response.data.attributes.status
            this.image = response.data.attributes.path
            
        })
        Vue.$topicService.topicList().then((response)=>{
            this.topics = response.data
        })
    },
    methods: {
        save() {
            Vue.$stepService.update({
                name:this.data.name,
                topic_id:this.data.topic_id,
                status:this.data.status
            },this.$router.currentRoute.params.id).then(()=>{
                this.$buefy.toast.open({
                    message:"Step saved!",
                    type:'is-success'
                });
                this.$store.commit("SET_ERRORS", null);
                this.loading = false;

                this.$router.replace({ name: 'guide', query: { tabSelected: 'steps' }});
            })
        },
    }
}
</script>